import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import styles from './loading.module.css'

let timer
export function Loading(props) {
    const [visible, setVisible] = useState(props.visible)

    useEffect(() => {
        if (props.delay) {
            timer && clearTimeout(timer)
            if (props.visible) {
                timer = setTimeout(() => setVisible(true), props.delay)
            } else {
                setVisible(false)
            }
        } else {
            setVisible(props.visible)
        }
    }, [props.visible, props.delay])

    return (
        <div className={styles.loading} {...attrs(props)}>
            {visible && (
                <div className={styles.loadingContainer}>
                    <div className={`${styles.loadingContent} a-loading a-primary a-m-10 a-loading-24`}></div>
                </div>
            )}
            {props.children}
        </div>
    )
}

Loading.propTypes = {
    loading: PropTypes.bool,
    delay: PropTypes.number
}

const notAttrsList = ['visible']
const attrs = (props) => {
    const ret = {}
    Object.keys(props).forEach((k) => {
        if (!notAttrsList.includes(k)) {
            ret[k] = props[k]
        }
    })
    return ret
}
